import React, { useEffect, useState } from "react";
import images from '../images/pic.jpg'
import pics from '../images/staycool.jpg'

import { mainTable } from '../css/Common'
import { useNavigate } from "react-router-dom";
import InputText from "../ReusableComponents/InputText";
import MainPopup from "../popup-containers/MainPopup";
import ForgetPassword from "../popup-containers/ForgetPassword";
import ResetPassword from "../popup-containers/ResetPassword";
import InputPassword from "../ReusableComponents/InputPassword";
import { useUserCapability } from "../components/ConstantReducerProvider";
import { IUDAPI, LoginAPI, authenticationAPI } from "../services/APIConnection";
import DropDown from "../ReusableComponents/DropDown";
import { toast, ToastContainer } from "react-toastify";
import logo from "../image/StayCool.png";




  
const Logindemo = () => {

  const { state, dispatch } = useUserCapability();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [password, setPassword] = useState("");

  const [currentData, setCurrentData] = useState([]);

  const [popUpDesign, setPopUpDesign] = useState(false);
  const [popUpForgetPwd, setPopUpForgetPwd] = useState(false);
  const [resetPopUp, setResetPopUp] = useState(false);
  const [visibleSdp, setVisibleSdp] = useState(false);
  const [sdp, setSdp] = useState([]);
  const [table, setTableData] = useState({});
  const [tableSdpData, setTableSdpData] = useState({});
  const [sdpValue, setSdpValue] = useState("");
  const [sdpValues, setSdpValues] = useState("");
  const [sdpError, setSDPError] = useState("");
  const [userProfilePopUp, setUserProfilePopUp] = useState(false);
  const [forgotPasswordDesign, setForgotPasswordDesign] = useState(false);
  const [resetPasswordDesign, setResetPasswordDesign] = useState(false);

  const [loginResponse, setLoginResponse] = useState([]);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [disabledGoBtn, setDisabledGoBtn] = useState(false);

  const navigate = useNavigate();
  const getBranch = (tableDatas) => {
    if (tableDatas.Table1 && tableDatas.Table1.length === 1) {
      setTimeout(() => {
        navigate("/dashboard");
      }, 4000);
    } else {
      setDisabledBtn(false);
      // setVisibleSdp(true);
      // const newSdp = tableDatas.Table1.map((userProfile) => ({
      //   value: userProfile.MstSDPId,
      //   label: userProfile.SDP_en,
      // }));
      // setSdp(newSdp);
      setTableData(tableDatas.Table1);
      const tableData = tableDatas.Table1;
      const sdpValues = tableData.map((item) => item.MstSDPId);
      setSdpValues(sdpValues);
    }
  };
  const handleSubmit = async () => {

    if (email != "" && password != "") {
      setEmailError("");
      setPasswordError("");
      setDisabledBtn(true);
      const loginPayload = {
        userName: email,
        password: password,
      };
      sessionStorage.setItem("userName", email);
      sessionStorage.setItem("password", password);
      const response = await authenticationAPI(
        loginPayload,
        "LoginAPI/LoginValid"
      );

      if (response && response.data && response.data.jsonString) {
        localStorage.setItem("jwtToken", response.data.token);
        let tableDatas = JSON.parse(response.data.jsonString);
        if (tableDatas.Table[0].Result === "LS") {
          toast.warn(
            `You have already logged in to another device. Try to login after sometimes`,
            {
              duration: 5000,
              position: "top-center",
            }
          );
          setDisabledBtn(false);
        } else if (tableDatas.Table[0].Result === "S") {
          const createdBy = sessionStorage.getItem("createdBy");
          let userId = tableDatas.Table1[0].MstUserId;
          // const loginPayload = [
          //   {
          //     mstUserId: tableDatas.Table1[0].MstUserId,
          //     status: 1,
          //   },
          // ];
          // const response = await IUDAPI(loginPayload, "UserAPI/IUDLogin");
          const loginPayload1 = {
            sessionId: 0,
            mstUserId: userId,
            lastActivity: new Date().toISOString(),
            isActive: 1,
            flag: 1
          };
          const response1 = await LoginAPI(loginPayload1, "Login/Login");
          if (response1.success) {
            // Handle the case when Result is "U"
            toast.success("Login Successful.", {
              duration: 5000,
              position: "top-center",
            });
            getBranch(tableDatas);
            setLoginResponse(tableDatas);
          }
        } else if (tableDatas.Table[0].Result === "R") {
          // Handle the case when Result is "U"
          setCurrentData(tableDatas.Table1[0]);
          handleResetPassword(true);
          setDisabledBtn(false);
        } else if (tableDatas.Table[0].Result === "WU") {
          setEmailError("Please enter a valid email  or phone no.");
          setPasswordError("");
          setDisabledBtn(false);
        } else if (tableDatas.Table[0].Result === "WP") {
          setEmailError("");
          setPasswordError("Enter a valid password");
          setDisabledBtn(false);
        } else {
          setEmailError("Please enter a valid email  or phone no.");
          setPasswordError("Enter a valid password");
          setDisabledBtn(false);
        }

        //get Session Values

        if (response && response.data) {
          // Check if Table1 exists and is not empty
          if (tableDatas.Table1 && tableDatas.Table1.length === 1) {
            // Access the desired value from the first item in Table1
            const createdBy = tableDatas.Table1[0].MstUserId;
            sessionStorage.setItem("createdBy", createdBy);
            const MstClientId = tableDatas.Table1[0].MstClientId;
            sessionStorage.setItem("MstClientId", MstClientId);
            dispatch({ type: "USER_PROFILE", payload: tableDatas.Table1 });
          }
          // Set user capability data
          if (tableDatas.Table2) {
            dispatch({
              type: "USER_VS_CAPABILITY",
              payload: tableDatas.Table2,
            });
          }
        }
      } else {
        setEmailError("Please enter a valid email  or phone no.");
        setPasswordError("Enter a valid password");
        setDisabledBtn(false);
      }
    } else {
      if (email == "" && password == "") {
        setEmailError("Enter email or phone no");
        setPasswordError("Enter password");
        setDisabledBtn(false);
      } else {
        if (email == "") {
          setEmailError("Enter email or phone no");
          setPasswordError("");
          setDisabledBtn(false);
        }
        if (password == "") {
          setEmailError("");
          setPasswordError("Enter password");
          setDisabledBtn(false);
        }
      }
    }
  };
  const handleClose = () => {
    setPopUpForgetPwd(false);
    setResetPopUp(false);
  };
  const handleClose1 = () => {
    setUserProfilePopUp(false);
  };

  const handleOpen = (isOpen) => {
    setPopUpForgetPwd(isOpen);
  };
  const handleOpen1 = (isOpen) => {
    setResetPopUp(isOpen);
  };
  const handleForgetPassword = () => {
    handleOpen(true);
    setPopUpDesign(true);
    setForgotPasswordDesign(true);
  };
  const handleSupplierRegistration = () => {
    setUserProfilePopUp(true);
  };
  const handleResetPassword = () => {
    handleOpen1(true);
    setResetPasswordDesign(true);
  };
  const handleSdpDropdownChange = (e) => {
    setSdpValue("");
    setSDPError("");
    const selectedValue = e.target.value;
    setSdpValue(selectedValue);

    const user = table.find((item) => item.MstSDPId == selectedValue);

    if (user) {
      const updatedUser = {
        ...user,
        AllSDP: sdpValues, // Assuming sdpValues is defined in your component
      };
      setTableSdpData(updatedUser);
    } else {
      console.log("User not found");
    }
    sessionStorage.setItem("AllSDP", sdpValues);
  };


  // const handleGo = () => {
  //   if (Object.keys(tableSdpData).length === 0 || sdpValue == "") {
  //     // Check if Table1 exists and is not empty
  //     if (sdpValue == "") {
  //       setSDPError("Select S.D.P.");
  //     }

  //     // return;
  //   } else {
  //     setDisabledGoBtn(true);
  //     if (tableSdpData) {
  //       // Access the desired value from the first item in Table1
  //       const createdBy = tableSdpData.MstUserId;
  //       sessionStorage.setItem("createdBy", createdBy);

  //       dispatch({ type: "USER_PROFILE", payload: [tableSdpData] });
  //     }
  //     setTableSdpData({});
  //     setTimeout(() => {
  //       navigate("/dashboard");
  //     }, 4000);
  //   }
  // };

  return (
    <>

<div className="grid grid-cols-1 md:grid-cols-2 h-screen overflow-hidden">

        <div >
          <img
            src={images}
            alt="sample"
            className="w-full h-full  "
          />
        </div>
        <div className='w-full p-6 shadow-lg bg-[#F3F4F6] '>

      
          {/* <div className='flex justify-center items-center py-2' >
             <img
              src={pics}
              alt="sam"
              className="w-1/2 h-1/2 "
            />
          </div> */}
          <div>
      <ToastContainer />
      <section class={mainTable.signupBackground}>
        <div class={mainTable.signMainContent}>
          <div class={mainTable.signupShadow}>
            <div class={mainTable.signupSpaceing}>
              <div class="flex justify-center items-center mb-1 text-2xl font-semibold text-gray-900 ">
                <img src={logo} className="h-24" alt="customer Logo" />
              </div>
              <h1 class={mainTable.signupTitle}>Sign in to your account</h1>
              <form class={mainTable.formSpace} action="#">
                <InputText
                  title="Email"
                  type="email"
                  name="email"
                  placeholder="Enter Email"
                  content={email}
                  controlFunc={(e) => setEmail(e.target.value)}
                  controlFuncBlur={(e) => {
                    setEmail(e.target.value);
                    setEmailError(
                      email.length > 0 ? "" : "Enter email or phone no"
                    );
                  }}
                />
                {emailError && <span class="text-red-500">{emailError}</span>}

                <InputPassword
                  title="Password"
                  name="password"
                  placeholder="Enter your password"
                  content={password}
                  controlFunc={(e) => setPassword(e.target.value)}
                  controlFuncBlur={(e) => {
                    setPassword(e.target.value);
                    setPasswordError(
                      password.length > 0 ? "" : "Enter password"
                    );
                  }}
                />
                {passwordError && (
                  <span class="text-red-500">{passwordError}</span>
                )}

                <div class="flex items-center justify-end">
                  <a
                    href="#s"
                    class="text-sm font-medium text-red-600 hover:underline "
                    onClick={() => handleForgetPassword()}
                  >
                    Forgot password?
                  </a>
                </div>
                <button
                  data-modal-hide="bottom-right-modal"
                  type="button"
                  className={
                    disabledBtn
                      ? mainTable.loginBtnDisabled
                      : mainTable.loginBtn
                  }
                  onClick={() => handleSubmit()}
                  disabled={disabledBtn}
                >
                  Sign in
                </button>
                {visibleSdp && (
                  <div>
                    <DropDown
                      title="S.D.P."
                      options={sdp}
                      classStar={"text-red-500"}
                      placeholder="Select"
                      name="sdp"
                      selectedOption={sdpValue}
                      controlFunc={handleSdpDropdownChange}
                    />
                    {sdpError && (
                      <span class="text-red-500 text-sm  font-medium">
                        {sdpError}
                      </span>
                    )}
                  </div>
                )}
                {/* {visibleSdp && (
                  <button
                    data-modal-hide="bottom-right-modal"
                    type="button"
                    className={
                      disabledGoBtn
                        ? mainTable.loginBtnDisabled
                        : mainTable.loginBtn
                    }
                    onClick={() => handleGo()}
                    disabled={disabledGoBtn}
                  >
                    Go
                  </button>
                )} */}
              </form>
            </div>
          </div>
        </div>
      </section>
      <MainPopup
        popUpOpen={popUpForgetPwd}
        setpopUpOpen={setPopUpForgetPwd}
        Open={handleForgetPassword}
        loginPopups={forgotPasswordDesign}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={handleClose}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <ForgetPassword
            closePopup={() => setPopUpForgetPwd(!popUpForgetPwd)}
          />
        </div>
      </MainPopup>
      <MainPopup
        popUpOpen={userProfilePopUp}
        setpopUpOpen={setUserProfilePopUp}
        loginPopups={true}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={handleClose1}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          {/* <PartnerRegistration
            closePopup={() => setUserProfilePopUp(!userProfilePopUp)}
          /> */}
        </div>
      </MainPopup>
      <MainPopup
        popUpOpen={resetPopUp}
        setpopUpOpen={setResetPopUp}
        Open={handleResetPassword}
        loginPopups={resetPasswordDesign}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={handleClose}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <ResetPassword
            data={currentData}
            closePopup={() => setResetPopUp(!resetPopUp)}
          />
        </div>
      </MainPopup>
    </div>
        </div>
      </div>
    </>
  )
}

export default Logindemo
